import { Action } from "@ngrx/store";

export const SET_ORDER_COMMENTS = "[ORDER COMMENTS] Set Order Comments";
export const SET_ORDER_PRIORITY_SCREEN_USERNAME =
  "[ORDER COMMENTS] Set Order Priority Screen Username";

export class SetOrderComments implements Action {
  readonly type = SET_ORDER_COMMENTS;
  constructor(public payload: any) {}
}

export class SetOrderPriorityScreenUsername implements Action {
  readonly type = SET_ORDER_PRIORITY_SCREEN_USERNAME;
  constructor(public payload: any) {}
}

export type OrderCommentsActions =
  | SetOrderComments
  | SetOrderPriorityScreenUsername;
